import React from 'react'

const MNavbar = () => {
  return (
    <div></div>
  )
}

export default MNavbar